<template lang="pug">
  transition(name="confirm-dialog-trans")
    .ssp-confirm-dialog(@click="close" v-if="isOpen")
      .confirm-dialog-content.flex-col
        .text-center
          .confirm-dialog-header
            h4.confirm-dialog-title {{ content.title }}
            hr
          .confirm-dialog-body
            p(v-html="content.text")
            hr
          .confirm-dialog-footer
            .test
              button.btn(@click="confirm" :class="`btn-${content.confirmButtonType}`") {{ content.confirmButtonText  }}
              button.btn(@click="cancel" :class="`btn-${content.cancelButtonType}`") {{ content.cancelButtonText }}

</template>

<script>
export default {
  data: () => ({
    isOpen: false,
    content: {}
  }),
  mounted() {
    window.addEventListener('keydown', this.handleKeyDown)
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeyDown)
  },
  methods: {
    confirm() {
      this.isOpen = false
    },
    cancel() {
      this.isOpen = false
    },
    close(event) {
      if (event.target && event.target.className === 'ssp-confirm-dialog') {
        this.cancel()
      }
    },
    handleKeyDown(e) {
      if (this.isOpen) {
        switch (e.key) {
          case 'Escape':
            this.cancel()
            break
          default:
            break
        }
      }
    }
  }
}
</script>

<style lang="scss">
.confirm-dialog-trans-enter {
  opacity: 0;
}
.confirm-dialog-trans-enter-active, .confirm-dialog-trans-leave-active {
  transition: all .4s;
}
.confirm-dialog-trans-enter-active, .confirm-dialog-trans-leave-active{
  transition: all .4s;
}
.confirm-dialog-trans-leave-active {
  opacity: 0;
}

.ssp-confirm-dialog {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
  .confirm-dialog-content {
    min-width: 40vw;
    border-radius: 3px;
    background: white;
    border: solid gray 1px;
    box-shadow: 1px 1px 1px 1px gray;
    padding: 10px;
  }
  .confirm-dialog-footer {
    button {
      margin: 0 10px 0 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/plugins/ConfirmDialog/ConfirmDialog.vue